import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TGetPayCardArtResponse } from "./getPayCardArt.schema";

export const getPayCardArt = (axios: IAxiosInstance) => {
  return async () => {
    const { data: resData } =
      await axios.noRetry.get<IApiResponse<TGetPayCardArtResponse>>(
        `/api/pay-cards/art`
      );

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
